<template>
    <div>
        <AboutUsTop />
        <div class="titleStyle">
            <div class="titleFont">发展历程</div>
            <div class="conentFont">
                <div class="divide"></div>
                <span class="enFont">THE DEVELOPMENT COURSE</span>
                <div class="divide"></div>
            </div>
        </div>
        <div class="radioStyle typeArea">
            <table cellpadding="0" cellspacing="0">
                <tr v-for="(item, idx) in dataList" :key="idx">
                    <td
                        width="507"
                        :class="[idx % 2 == 0 ? 'leftDescription' : '']"
                    >
                        <div
                            :class="[
                                idx % 2 == 0 ? 'leftDescriptionTitle' : '',
                            ]"
                        >
                            {{ idx % 2 == 0 ? item.title : "" }}
                        </div>
                        <div
                            :class="[
                                idx % 2 == 0 ? 'leftDescriptionContent' : '',
                            ]"
                        >
                            {{ idx % 2 == 0 ? item.description : "" }}
                        </div>
                    </td>
                    <td width="30"></td>
                    <td width="26">
                        <div class="radioMiddle">
                            <div class="radioTop"></div>
                            <div class="radioBottom"></div>
                        </div>
                    </td>
                    <td width="30"></td>
                    <td
                        width="507"
                        :class="[idx % 2 == 1 ? 'rightDescription' : '']"
                    >
                        <div
                            :class="[
                                idx % 2 == 1 ? 'rightDescriptionTitle' : '',
                            ]"
                        >
                            {{ idx % 2 == 1 ? item.title : "" }}
                        </div>
                        <div
                            :class="[
                                idx % 2 == 1 ? 'rightDescriptionContent' : '',
                            ]"
                        >
                            {{ idx % 2 == 1 ? item.description : "" }}
                        </div>
                    </td>
                </tr>
            </table>
        </div>
    </div>
</template>
<script>
import $ from "jquery";
import AboutUsTop from "@/components/AboutUsTop.vue";
import { getAction } from "@/api/services";
export default {
    name: "DevelopmentCourse",
    components: {
        AboutUsTop,
    },
    data() {
        return {
            url: "/jhwlweb/gwweb/cmsArticleCategory/queryAboutusList",
            topList: [],
            dataList: [],
            moveX: undefined,
            timer: null,
        };
    },
    created() {
        this.getInfo();
    },
    methods: {
        changeHeight() {
            let heightArr = [];
            let leftArr = $(".leftDescriptionContent").toArray();
            leftArr.forEach((item, idx) => {
                heightArr[idx * 2] = $(item).height() + 32;
            });
            let rightArr = $(".rightDescriptionContent").toArray();
            rightArr.forEach((item, idx) => {
                heightArr[idx * 2 + 1] = $(item).height() + 32;
            });
            heightArr[heightArr.length - 1] =
                heightArr[heightArr.length - 1] - 32;
            let rbArr = $(".radioBottom");
            for (let i = 0; i < rbArr.length; i++) {
                rbArr.eq(i).height(heightArr[i]);
            }
        },
        getInfo() {
            let that = this;
            let parmas = {
                menuCategory: 90,
                pageSize: 100,
            };
            getAction(that.url, parmas).then((res) => {
                if (res.code == 200 && res.success) {
                    res.result.records.forEach((item) => {
                        if (item.showTop == 1) {
                            that.topList.push(item);
                        }
                        that.dataList.push(item);
                    });
                    setTimeout(() => {
                        that.changeHeight();
                    }, 100);
                }
            });
        },
    },
};
</script>
<style lang="less" scoped>
.typeArea {
    max-width: 1100px;
    margin: 0 auto;
}
.titleStyle {
    .typeArea();
    padding-bottom: 80px;
    padding-top: 90px;
    text-align: center;
    width: 100%;
    .titleFont {
        font-family: "阿里巴巴普惠体";
        font-size: 32px;
        line-height: 28px;
        letter-spacing: 2px;
        color: #333333;
    }
    .conentFont {
        margin-top: 8px;
        .divide {
            display: inline-block;
            vertical-align: super;
            width: 20px;
            height: 2px;
            background-color: #0052d9;
        }
        .enFont {
            margin: 0 10px;
            font-family: "微软雅黑";
            font-size: 16px;
            letter-spacing: 0px;
            color: #333333;
            opacity: 0.5;
        }
    }
}
.radioStyle {
    margin-bottom: 40px;
    .leftDescription {
        position: relative;
        color: #0052d9;
        .leftDescriptionTitle {
            position: absolute;
            right: 0;
            top: -12px;
            height: 32px;
            font-size: 24px;
        }
        .leftDescriptionContent {
            position: absolute;
            right: 0;
            top: 20px;
            text-align: right;
            font-size: 16px;
        }
    }
    .rightDescription {
        position: relative;
        color: #0052d9;
        .rightDescriptionTitle {
            position: absolute;
            left: 0;
            top: -12px;
            height: 32px;
            font-size: 24px;
        }
        .rightDescriptionContent {
            position: absolute;
            left: 0;
            top: 20px;
            font-size: 16px;
        }
    }
    .radioMiddle {
        .radioTop {
            height: 26px;
            width: 26px;
            border-radius: 50%;
            background: #0052d9;
        }
        .radioBottom {
            margin: 0 auto;
            width: 4px;
            height: 106px;
            background: #0052d9;
        }
    }
}
</style>
